import { ChainId } from '@src/configs/chainInfo'

export const QUICKNODE_RPCS = {
    [ChainId.Ethereum]: ['https://long-capable-tree.quiknode.pro/4f8abee71b92694624d5f6a5aac43bf273b76db1/'],
    [ChainId.Optimism]: ['https://alien-dry-lake.optimism.quiknode.pro/9e3364e544a78fa0581658f542d58d8c02cd13ba/'],
    [ChainId.Bsc]: ['https://necessary-thrumming-diamond.bsc.quiknode.pro/f2f3a08170d298c0bd742d77ea0462afcec15dd4/'],
    [ChainId.BscTestnet]: [
        'https://fittest-shy-orb.bsc-testnet.quiknode.pro/4d8b9a2d005aa4ed2cefcac0a181aef03ec9a8c3/',
    ],
    [ChainId.Polygon]: ['https://holy-restless-vineyard.matic.quiknode.pro/559b966d2ea5ab37e95abee0cf1049a10971e30d/'],
    [ChainId.Opbnb]: ['https://opbnb-rpc.publicnode.com'],
    [ChainId.Base]: [
        'https://polished-spring-star.base-mainnet.quiknode.pro/19455fd433fb2639609315f8588c3a58a5a9a10f/',
    ],
    [ChainId.Arbitrum]: [
        'https://prettiest-patient-scion.arbitrum-mainnet.quiknode.pro/2d53fa7ffc71e31afb3113f96c54519fcd6516e2/',
    ],
    [ChainId.Celo]: [
        'https://attentive-alien-water.celo-mainnet.quiknode.pro/9c1b86178a6c7ebc5c772663ac82b51003ef8a81/',
    ],
    [ChainId.Avalanche]: [
        'https://withered-soft-field.avalanche-mainnet.quiknode.pro/f0478bf89e96d35ee8351213a1120fe4ba292849/ext/bc/C/rpc/',
    ],
    [ChainId.Blast]: [
        'https://warmhearted-few-scion.blast-mainnet.quiknode.pro/22d44d1f9a1a57adf90c0efd2d644977c3dd5a23/',
    ],
    [ChainId.Scroll]: [
        'https://sleek-crimson-flower.scroll-mainnet.quiknode.pro/37e22c7823176a82f7cea7b89b5c37786b76a810/',
    ],
    [ChainId.Mantle]: [
        'https://still-compatible-wind.mantle-mainnet.quiknode.pro/277b01e4afb73df889a08ba018dc14e354f5f0da/',
    ],
    [ChainId.Mode]: ['https://1rpc.io/mode'],
    [ChainId.Unichain]: ['https://unichain-mainnet.g.alchemy.com/v2/yHZvr09DRycjGM-t-j5hkUvOgfgx8gbt'],
    [ChainId.MonadTestnet]: ['https://testnet-rpc.monad.xyz'],
    [ChainId.Sepolia]: ['https://ethereum-sepolia-rpc.publicnode.com'],
    [ChainId.MegaEthTestnet]: ['https://carrot.megaeth.com/rpc'],
}
